import { Flexbox, ListManager } from '@/components'
import PropTypes from 'prop-types'
import React, {
 useCallback, useEffect, useState,
} from 'react'
import clinicalCares from '@/services/api/clinicalCares'
import ClinicalCareCard from '../ClinicalCareCard'

function ClinicalCareHospitalized({ clinicId }) {
  const [list, setList] = useState([])
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)

  const fetchList = useCallback(async () => {
    try {
      setLoading(true)
      const { data } = await clinicalCares.inHospital(clinicId)
      setList(data)
    } catch (e) {
      setError(e)
    } finally {
      setLoading(false)
    }
  }, [clinicId])

  useEffect(() => {
    fetchList()
  }, [fetchList])

  return (
    <ListManager
      count={list.length}
      error={error}
      loading={loading}
      emptyIcon="fas fa-stethoscope"
      emptyMessage="Nenhum atendimento em andamento"
      emptySubtitle="A clínica não possui atendimentos em andamento"
      emptyAction={(
        <a onClick={fetchList} className="btn btn-primary btn-sm">
          <i className="fas fa-sync-alt" />
          &nbsp;Buscar novamente
        </a>
      )}
    >
      <Flexbox.Columns>
        {
          list.map((clinicalCare) => (
            <Flexbox.Column key={clinicalCare.id} className="col-sm-12 col-6 my-2">
              <ClinicalCareCard hideLateMessage clinicalCare={clinicalCare} />
            </Flexbox.Column>
          ))
        }
      </Flexbox.Columns>
    </ListManager>
  )
}

ClinicalCareHospitalized.propTypes = {
  clinicId: PropTypes.number.isRequired,
}

export default ClinicalCareHospitalized
